import { merge } from '../../helper';

import addClass from '../../general/class/addClass';
import insertAfter from '../../general/insertAfter';
import insertBefore from '../../general/insertBefore';
import isEmptyArray from '../../general/isEmpty/isEmptyArray';
import isEmptyObject from '../../general/isEmpty/isEmptyObject';

import * as exButton from '../button';
import * as exDropdown from '../dropdown';
import * as exElement from '../../utils/element';
import * as exLink from '../../utils/link';

// ----------------------------------------------------------------------------

function data(element: HTMLElement, config: Record<string, any> = {}): any[] {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const list: any[] = [];

    // Foreach Data
    for (const itemA of defConfig.data) {
        // If itemA is object
        if (!isEmptyObject(itemA)) {
            // Create element (list item)
            const listItem = add({
                merge: {
                    ...defConfig,
                    ...itemA,
                },
            });
            element.appendChild(listItem.element);

            // List Push
            list.push(listItem.element);
        }
        // If itemA is array
        else if (!isEmptyArray(itemA)) {
            // Foreach ItemB
            for (const itemB of itemA) {
                // Create element (list item)
                const listItem = add({
                    merge: defConfig,
                    html: itemB,
                });
                element.appendChild(listItem.element);

                // List Push
                list.push(listItem.element);
            }
        }
    }

    // Return
    return list;
}

// ----------------------------------------------------------------------------

function add(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    //
    if (isEmptyObject(defConfig.dropdown)) {
        // Create element (item)
        const elItem = exElement.create({
            merge: defConfig,
            tag: 'li',
            html: defConfig.html,
        });
        elements.element = elItem;

        // If using active
        if (defConfig.active === true) {
            addClass(elItem, 'active');
        }

        // --------------------------------------------------------------------

        // If using link
        if (!isEmptyObject(defConfig.link)) {
            // Create element (link)
            const link = exLink.create({
                merge: defConfig.link,
            });
            elItem.appendChild(link.element);
            elements.link = link;
        }
        // If using button
        else if (!isEmptyObject(defConfig.button)) {
            // Create element (button)
            const button = exButton.create({
                merge: defConfig.button,
            });
            elItem.appendChild(button.element);
            elements.button = button;
        }
    }
    //
    else {
        // Create element (dropdown)
        const dropdown = exDropdown.create({
            merge: defConfig.dropdown,
        });
        elements.element = dropdown.element;
        elements.dropdown = dropdown;
    }

    // ------------------------------------------------------------------------

    // If using divider
    if (defConfig.divider && typeof defConfig.divider.insert === 'string') {
        const elDivider = divider(defConfig.divider);

        // If divider is after
        if (defConfig.divider.insert === 'after') {
            insertAfter(elDivider, elements.element);
        }
        // If divider is before
        else if (defConfig.divider.insert === 'before') {
            insertBefore(elDivider, elements.element);
        }
    }

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

// ----------------------------------------------------------------------------

function divider(config: Record<string, any> = {}): HTMLElement {
    // Create element (divider)
    const elDivider = exElement.create({
        merge: config,
        tag: 'hr',
        class: {
            new: 'divider',
        },
    });

    // Return
    return elDivider;
}

// ----------------------------------------------------------------------------

export { data, add, divider };
